<div class="panel">
    <slot></slot>
</div>

<style>
    @import "../../../main.css";

    .panel {
        @apply flex h-full w-full flex-col overflow-auto bg-gray-100 !important;
    }
</style>
